import { THEME_MODE } from '../services/api';

const PROD_COLORS = {
  // Primary / Brand
  primary: '#233F8C',
  secondary: '#4D6FBF',
  accent: '#2EC9FF',
  success: '#34C759',
  warning: '#4D6FBF',
  error: '#FF3B30',

  // Backgrounds
  background: '#F5F7FC',
  backgroundDark: '#1C3476',
  cardBackground: '#FFFFFF',

  // Text
  text: '#1F3A8A',
  textLight: '#6B7280',
  textInverse: '#FFFFFF',

  // Component colors
  divider: '#D8E2F7',
  inactive: '#7A8BB5',
  border: '#2C4D9E',

  // Status colors
  syncReady: '#34C759',
  syncProcessing: '#2EC9FF',
  syncError: '#FF3B30',
};

const DEV_COLORS = {
  // Primary / Brand
  primary: '#4B4F56',
  secondary: '#6B7078',
  accent: '#8B919A',

  // Semantic colors
  success: '#34C759',
  warning: '#4D6FBF',
  error: '#FF3B30',

  // Backgrounds
  background: '#F3F4F5',
  backgroundDark: '#2F3237',
  cardBackground: '#FFFFFF',

  // Text
  text: '#34373C',
  textLight: '#747981',
  textInverse: '#FFFFFF',

  // Component colors
  divider: '#D9DBDE',
  inactive: '#8A8F96',
  border: '#797E86',

  // Status colors
  syncReady: '#34C759',
  syncProcessing: '#2EC9FF',
  syncError: '#FF3B30',
};

const Colors = THEME_MODE === 'dev' ? DEV_COLORS : PROD_COLORS;

function hexToRgbChannels(hex: string): string {
  const clean = hex.replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  return `${r}, ${g}, ${b}`;
}

export function withAlpha(hex: string, alpha: number): string {
  return `rgba(${hexToRgbChannels(hex)}, ${alpha})`;
}

export function toRgbChannels(hex: string): string {
  return hexToRgbChannels(hex);
}

export default Colors;
